import { IIntegrationBaseProps } from '../types';

export enum DefenseUserTypes {
  SYSTEM_USER = 'SYSTEM_USER',
  DOMAIN_USER = 'DOMAIN_USER',
}

export interface IDefenseCreateProps extends IIntegrationBaseProps {
  username: string;
  password: string;
  serverIp: string;
  httpPort: number;
  mqttPort: number;
  userType: DefenseUserTypes;
}

export interface IDefenseUpdateProps extends IIntegrationBaseProps {
  username: string;
  password: string;
  serverIp: string;
  httpPort: number;
  mqttPort: number;
  userType: DefenseUserTypes;
}

export interface IDefenseUpdateParams {
  id: number;
  data: IDefenseUpdateProps;
}

export interface IDefenseProps extends IIntegrationBaseProps {
  id: number;
  username: string;
  password: string;
  serverIp: string;
  httpPort: number;
  mqttPort: number;
  userType: DefenseUserTypes;
}

export const getNameOfDefenseUserType = (userType: DefenseUserTypes) => {
  switch (userType) {
    case DefenseUserTypes.SYSTEM_USER:
      return 'Usuário do Sistema';
    case DefenseUserTypes.DOMAIN_USER:
      return 'Usuário de Domínio';
    default:
      return 'Usuário Desconhecido';
  }
};
